<template>
  <div>
    <div class="post-inner overflow-hidden rounded-lg bg-white shadow-[0px_0px_35px_rgba(0,0,0,0.08)]">
      <div class="bg-gradient-to-r from-gray-200 to-gray-500">
        <NuxtImg
          v-if="topImage"
          class="post-img mb-10 h-[274px] w-full object-cover"
          :src="topImage"
          :alt="topImageAlt ?? ''"
          sizes="sm:468px md:648px xxl:1140px"
          format="webp"
          width="1140"
          height="450"
          :placeholder="getBlogPlaceholderForKey(topImage)"
        />
      </div>
      <div
        class="post-content px-[8%] pb-[12%] text-[1.0625rem] leading-[1.7]"
        v-html="htmlText"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { getBlogPlaceholderForKey } from "~/shared/composables/useBlogPlaceholder";

defineProps<{
  htmlText: string;
  topImage?: string;
  topImageAlt?: string;
}>();

</script>

<style scoped>
.post-content :deep(p) {
  text-align: left;
  line-height: 2;
}
.post-content :deep(p:not(:last-child)) {
  margin-bottom: 1.5em;
}
.post-content :deep(h2) {
  text-align: left;
  font-size: 1.625rem;
  line-height: 1.38;
}
.post-content :deep(h2:not(:last-child)) {
  margin-bottom: 0.6em;
}
.post-content :deep(ul:not(:last-child)) {
  margin-bottom: 1.5em;
}
.post-content :deep(a) {
  color: #3ca25a !important;
}
.post-content :deep(a *) {
  color: #3ca25a !important;
}
.post-content :deep(img) {
  max-width: 100% !important;
  height: auto !important;
  border-radius: 8px;
}
.post-content :deep(img:not(:last-child)) {
  margin-bottom: 30px;
}

@media (min-width: 768px) {
  .post-img {
    height: auto;
  }
}

@media (min-width: 1024px) {
  .post-content {
    padding-left: 90px;
    padding-right: 90px;
    padding-bottom: 130px;
  }
  .post-content :deep(h2) {
    font-size: 1.875rem;
  }
}
</style>
